export const enum SidebarButtonType {
  profile = 'Profile',
  assessments = 'Assessments',
  notes = 'Notes',
  refer = 'Refer',
  scheduling = 'Scheduling'
}
